Date.prototype.removeTime = function() {
    this.setUTCHours(0)
    this.setMinutes(0)
    this.setSeconds(0)
    this.setMilliseconds(0)
    return this
}
